import axios from 'axios';

export const AddCompanyAPI = async (data, onSuccess, onError)=>{
    try{
        const res = await axios.post("/add/company", data, {
            headers: {
                "Content-Type": "application/json"
            },
            withCredentials: true,
            baseURL: "https://salty-reaches-69347.herokuapp.com/"
        });

        onSuccess && onSuccess(res);
    }
    catch(err){
        onError && onError(err);
    }
};